export const profile = {
  name: "Hunter Grey",
  email: "grey@huntergrey.cn",
  gitlab: "https://git.huntergrey.cn/grey",
  github: "https://github.com/HunterGrey-cyber",
  linkedin: "https://www.linkedin.com/in/hunter-grey-b744bb267/",
  portal: "https://portal.huntergrey.cn",
  resume: "/profile/resume-en.pdf",
  site: "https://huntergrey.cn",
};

export const projects = [
  {
    id: "neovibe",
    name: "NeoVibe",
    category: "Developer tools",
    summary:
      "Neovim, AI coding sessions, and a terminal. One native workspace.",
    description:
      "An editor built around the way I work: write in Neovim, collaborate with an AI agent, and keep the terminal close. A native Rust shell brings the pieces together.",
    focus:
      "Recently I’ve been refining rendering, cursor motion, and resumable AI sessions, so moving between writing code and working with an agent feels more natural.",
    details: [
      ["Editing", "Embedded Neovim with GPU rendering through Skia."],
      [
        "AI sessions",
        "A React panel for coding conversations and session history.",
      ],
      [
        "Workspace",
        "Editor, agent, and terminal arranged in one native shell.",
      ],
    ],
    stack: ["Rust", "GTK", "Skia", "React"],
    url: "https://git.huntergrey.cn/grey/neovibe",
  },
  {
    id: "skuld",
    name: "Skuld",
    category: "Personal software",
    summary:
      "A task manager that works offline and follows you across devices.",
    description:
      "Tasks should be available wherever I’m working, even without a connection. Skuld keeps a local database on each client and synchronizes changes through a shared Go server.",
    focus:
      "The work spans web, desktop, mobile, and terminal clients, with local storage and a common sync model keeping them connected.",
    details: [
      [
        "Offline first",
        "Read and update tasks locally, then sync in the background.",
      ],
      [
        "Across devices",
        "Web, Qt desktop, Android, iOS, and a terminal interface.",
      ],
      [
        "Shared foundation",
        "A Go server and local databases, including SQLite and IndexedDB.",
      ],
    ],
    stack: ["Go", "SQLite", "Kotlin", "Swift"],
    url: "https://git.huntergrey.cn/grey/skuld",
  },
  {
    id: "draupnir",
    name: "draupnir",
    category: "Self-hosted infrastructure",
    summary:
      "A home for the packages and software I build, mirror, and distribute.",
    description:
      "A mirror and distribution service for my own software infrastructure. It brings package uploads, repository access, and authentication into one place.",
    focus:
      "Recent work brings APT, pacman, F-Droid, and NuGet distribution together with tiered access and shared sign-in.",
    details: [
      ["Distribution", "APT, pacman, F-Droid, and NuGet repositories."],
      ["Access", "Public, shared, and private tiers with OIDC sign-in."],
      [
        "Operations",
        "Go services backed by PostgreSQL and package upload APIs.",
      ],
    ],
    stack: ["Go", "PostgreSQL", "OIDC"],
    url: "https://git.huntergrey.cn/grey/draupnir",
  },
];

export const notes = [
  {
    title: "Making the editor feel right",
    text: "Rendering, cursor motion, and session continuity in NeoVibe.",
    to: "/projects#neovibe",
  },
  {
    title: "Keeping my own infrastructure running",
    text: "A homelab maintained as code, from containers to OpenWrt.",
    to: "/about",
  },
];

export const smallProjects = [
  {
    name: "life-tracker",
    description: "A personal logging tool, starting with sleep records.",
    detail: "Go, Vue, Tauri",
  },
  {
    name: "Vegvísir",
    description: "A small directory that brings my personal services together.",
    detail: "Personal service portal",
  },
  {
    name: "self-host",
    description: "The configuration behind my homelab, servers, and network.",
    detail: "Linux, Docker, OpenWrt",
  },
];
